import { Component, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { colorRampCanvas, parsePalette } from 'cpt2js';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.css']
})
export class LegendComponent {
  
  @Input() colorMap: string;
  @Input() rotate = false;
  @Input() width = 300;
  @Input() height = 60;

  colorMapHtml: string;
  domainMin: number;
  domainMax: number;
  domainMed: number;

  constructor(private translate: TranslateService) { }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['colorMap'].currentValue && changes['colorMap'].currentValue.length > 10)
    {
      this.createColorCanvas();

      //to fix top when showing legend or not
      let body = document.getElementsByClassName('ol-viewport')[0];
      if (body)
      {
        if (this.colorMap && this.colorMap.length > 5) body.classList.add("legend");   //add the class
        else body.classList.remove("legend");   //remove the class
      }
    }

  }

  createColorCanvas()
  {
    let palette = this.colorMap;
    
    if (this.colorMap.length > 10)
    {
      try {
        let paletteScale = parsePalette(palette);
            
        let paletteCanvas = colorRampCanvas(paletteScale, { width: this.width, height: this.height });
        
        let paletteCanvasDataUrl = paletteCanvas.toDataURL('image/png', 0.5);
        this.colorMapHtml = `<img src="${paletteCanvasDataUrl}"` +  (this.rotate ? " class='rotate-legend'" : '') + '>'; ;
        
        this.domainMax = paletteScale.domain()[1] / 1000;
        this.domainMin = paletteScale.domain()[0] / 1000;
        this.domainMed = (paletteScale.domain()[1] / 2) / 1000;
     }
     catch(e) {
        window.alert(this.translate.instant('legend.colormap-invalid'));
      }
    }
  }

  

}
